// Imports
//=require jquery/dist/jquery.min.js
//=require svg4everybody/dist/svg4everybody.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js
//=require slick-carousel/slick/slick.min.js

svg4everybody();

// Check Email
function checkEmail(email){
    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!filter.test(email)) {
        return false;
    }else{
        return true;
    }
}

/** 
 * Filter inputs
*/

function setInputFilter(textbox, inputFilter) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

// DOM
var MyApp = {
    menu: {
        open: function () {
            $('.button-overlay').click(function(event) {
                event.preventDefault();
                $('.site__body').toggleClass('site__body__hidden');
                $('.site-header').toggleClass('is-active');
                $('.main-navbar').toggleClass('main-navbar__active');
                $('.main-navbar__overlay__mobile').toggleClass('main-navbar__overlay__active');
            });
        },
        overlayDesktop: function () {
            $('.main-navbar__overlay__desktop').click(function() {
                $(this).removeClass('main-navbar__overlay__desktop__active');
            });
        },
        overlayMobile: function () {
            $('.main-navbar__overlay__mobile').click(function() {
                $('.site__body').removeClass('site__body__hidden');
                $('.site-header').removeClass('is-active');
                $('.main-navbar').removeClass('main-navbar__active');
                $(this).removeClass('main-navbar__overlay__active');
            });
        },
        submenu: function () {
            $('.dropbtnslide').on('click', function(e) {
                e.preventDefault();
            });
            $('.main-navbar__dropdown').click(function(){
                $btnDropdown = $('.main-navbar__dropdown__content',this);
                $btnDropicon = $('.main-navbar__dropdown__icon-down',this);
                if(($btnDropdown.hasClass('open'))){
                    $('.main-navbar__dropdown__content').removeClass('open').slideUp();
                    $('.main-navbar__dropdown__icon-down').removeClass('is-active');
                    $('.main-navbar__overlay__desktop').removeClass('main-navbar__overlay__desktop__active');
                    return;
                }

                $('.main-navbar__dropdown__content').slideUp().removeClass('open');
                $('.main-navbar__dropdown__icon-down').removeClass('is-active');
                $('.main-navbar__overlay__desktop').removeClass('main-navbar__overlay__desktop__active');

                $btnDropdown.slideDown().addClass('open');
                $btnDropicon.addClass('is-active');
                if ($('.site__body').width() >= 751){
                    $('.main-navbar__overlay__desktop').addClass('main-navbar__overlay__desktop__active');
                }
            });
        },
        closeSubmenu: function () {
            $('.site__body').click(function(event) {
                var dropbtnHide = $('.main-navbar__dropdown__content')
                if (!event.target.matches('.dropbtnslide')) {
                    dropbtnHide.hide("200");
                    dropbtnHide.removeClass('open');
                    $('.main-navbar__dropdown__icon-down').removeClass('is-active');
                    $('.main-navbar__overlay__desktop').removeClass('main-navbar__overlay__desktop__active');
                }
            });
        },
        windowResize: function () {
            $(window).resize(function(){
                if ($(window).width() > 767){
                    $('.site__body').removeClass('site__body__hidden');
                    $('.site-header').removeClass('is-active');
                    $('.main-navbar').removeClass('main-navbar__active');
                    $('.main-navbar__overlay__mobile').removeClass('main-navbar__overlay__active');
                    $('.main-navbar__dropdown__content').removeClass('open').slideUp();
                    $('.main-navbar__dropdown__icon-down').removeClass('is-active');
                }
            });
        },
        fixed: function () {
            var stickyHeader = $('.site-header__main');
        
            $(window).scroll(function() {
                if( stickyHeader.offset().top > 96 ) {
                    stickyHeader.addClass('sticky')
                } else {
                    stickyHeader.removeClass('sticky')
                }
            });
        }
    },
    onlyNumbers : function() {
        $('.only-numbers').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    },
    onlyLetters : function () {
        $('.only-letters').each(function () {
            setInputFilter(this, function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        });
    },
    onlyAlpaNumeric : function () {
        $('.only-alpha-numeric').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9a-zA-Z]*$/.test(value);
            });
        });
    },
    onlyPhone : function () {
        $('.only-phone').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\-]*$/.test(value);
            });
        });
    },
    onlyDate : function () {
        $('.only-date').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        });
    },
    quote : {
        form : function () {

            $.validator.addMethod("account", function (value, element) {
                if (value == '')
                    return true;
                var regex = /^([a-zA-Z]{2})+\-([0-9]{5,10})/;
                if (!regex.test(value)) {
                    return false;
                } else {
                    return true;
                }
            }, "The account format must be: XX-0123456789");

            $.validator.methods.email = function (value, element) {
                if (value == '')
                    return true;

                var regex = /^([a-zA-ZñÑ0-9_\.\-\+])+\@(([a-zA-ZñÑ0-9\-])+\.)+([a-zA-ZñÑ0-9]{2,4})+$/;
                if (!regex.test(value)) {
                    return false;
                } else {
                    return true;
                }
            }

            var zipcodeValue = $('[name="zipcode"]').val();

            $('.form').each(function() {
                $(this).validate({
                    errorPlacement: function(error, element) {
                        error.insertAfter(element);
                    },
                    highlight: function (element, errorClass, validClass) {
                        $(element).closest(".validate__item").addClass(errorClass).removeClass("validate__success")
                    },
                    unhighlight: function (element, errorClass, validClass) {
                        $(element).closest(".validate__item").removeClass(errorClass).addClass("validate__success")
                    },
                    errorElement:'span',
                    errorClass: 'validate__error',
                    rules:{
                        'lead[first_name]': {minlength:2},
                        'lead[last_name]': {minlength:2},
                        'lead[email]': { minlength: 3, maxlength: 255},
                        'lead[phone]': { minlength: 12, maxlength: 12},
                        'lead[zipcode]': {
                            digits: true,
                            minlength: 3,
                            maxlength: 5,
                            remote: {
                                url: 'https://confiejarvis.com/thor/javascript?',
                                dataFilter: function (data) {
                                    if (data === "1") {
                                        return '"true"';
                                    }
                                    return '"Zip Code invalid"';
                                }
                            }
                        },
                        'zipcode': {
                            digits: true,
                            minlength: 3,
                            maxlength: 5,
                            remote: {
                                url: 'https://confiejarvis.com/thor/javascript?',
                                dataFilter: function (data) {
                                    if (data === "1") {
                                        return '"true"';
                                    }
                                    return '"Zip Code invalid"';
                                }
                            }
                        },
                        AccountNumber: {
                            account: true
                        }
                    },
                    messages: {
                        'lead[gender]': {
                            required: 'Gender is required'
                        },
                        'lead[first_name]': {
                            required: 'First Name is required'
                        },
                        'lead[last_name]': {
                            required: 'Last Name is required'
                        },
                        'lead[email]': {
                            required: 'Email is required'
                        },
                        'lead[phone]': {
                            minlength: "You must enter 10 digits",
                            maxlength: "You must enter 10 digits",
                            required: 'Phone is required'
                        },
                        'lead[zipcode]': {
                            required: 'Zip Code is required'
                        },
                        'zipcode': {
                            required: 'Zip Code is required'
                        }
                    },
                    submitHandler: function(form) {
                        /*if (zipcodeValue !== '' ) {
                            $.getJSON('https://confiejarvis.com/thor/javascript?callback=?',{
                                zipcode: $('[name="zipcode"]').val(), method :'json', return_data:'true'
                            },
                            function(data){
                                if (data.response == 1) {
                                    $('.form').addClass('forms__loading');
                                    form.submit();
                                } else {
                                    $('.validate__error').remove();
                                    $('.error-zipcode').addClass('show-error').append('<span class="validate__error">Zip Code invalid</span>');
                                    $('.form').removeClass('forms__loading');
                                }
                            });
                        } else{
                            $('.form').addClass('forms__loading');
                            $('.error-zipcode').html('');
                            form.submit();
                        }*/
                        $('.form').addClass('forms__loading');
                        //$('.error-zipcode').html('');
                        form.submit();
                    }
                });
            });
            /*if (zipcodeValue !== '' ) {
                $('[name="zipcode"]').rules('remove', 'remote');
            }*/
        },

        phone : function () {
            $('.phone-mask').mask('000-000-0000');
        },
        
        /*addItem: function() {
            var quoteGruop = $('.quote-group');
            $('.add-item').click(function(event) {
                event.preventDefault();
                quoteGruop.addClass('quote-group_added');
                quoteGruop.clone().insertAfter('.quote-group:last');
            });
        },*/
        deleteItem: function() {
            $('body').on('click', '.quote-group__delete', function(event) {
                event.preventDefault();
                $(this).next('.delete-confirmation__container').addClass('fade-in');
            });
        },
        deleteItemYes: function() {
            $('body').on('click', '.delete-confirmation__button_yes', function(event) {
                event.preventDefault();
                $(this).parents('fieldset').nextAll('fieldset').each(function() {
                    var nextBlockTitle = $(this).find('p.quotes__steps__box-title');
                    nextBlockTitle.text(function(index, text){
                        var number = parseInt(text.split('#')[1]) - 1
                        var subject = text.split('#')[0];
                        return subject + '#' + number;
                    });
                });        
                $(this).closest('.quote-group').remove();
            });
        },
        deleteItemNo: function() {
            $('body').on('click', '.delete-confirmation__button_no', function(event) {
                event.preventDefault();
                $(this).closest('.delete-confirmation__container').addClass('fade-out').removeClass('fade-in');
            });
        },
        
        vehicles: {
            vehiclesForm: function () {
                $("body").on("click", ".delete-confirmation__button_yes", function () {
                    MyApp.quote.CheckCountForms();
                });
                MyApp.quote.CheckCountForms();
            },
            addVehicles: function () {
                var quoteGruop = $('.quote-group:first');
                var nameIncrement = 1;
                $(document).on('click', '.add-item_vehicle', function (event) {
                    event.preventDefault();
                    $('#title_step').html('Max 4 vehicles.')
                    var max = $(".quote-group").length;
                    if (max >= 4) {
                        $('.quotes__steps__box-another').hide();
                    }
                    
                    var total_forms = $(".quote-group").length;
                    var var_quoteGruop = quoteGruop.clone();
                    //
                    var names = var_quoteGruop.find('[name]');
                    var counter = 0;
                    while (counter < names.length) {
                        var currentName = $(names[counter]).attr('name');
                        var newName = currentName.substring(0, currentName.indexOf('['));
                        var posName = currentName.substring(currentName.indexOf(']') +1 );
                        $(names[counter]).attr('name', newName + '[' + nameIncrement +']'+posName);
                        counter++;
                    }
                    //
                    var names = var_quoteGruop.find('[id]');
                    var counter = 0;
                    while (counter < names.length) {
                        var currentName = $(names[counter]).attr('id');
                        var newName = currentName.substring(0, currentName.indexOf('['));
                        var posName = currentName.substring(currentName.indexOf(']') +1 );
                        $(names[counter]).attr('id', newName + '[' + nameIncrement +']'+posName);
                        counter++;
                    }
                    //
                    var names = var_quoteGruop.find('[for]');
                    var counter = 0;
                    while (counter < names.length) {
                        var currentName = $(names[counter]).attr('for');
                        var newName = currentName.substring(0, currentName.indexOf('['));
                        var posName = currentName.substring(currentName.indexOf(']') +1 );
                        $(names[counter]).attr('for', newName + '[' + nameIncrement +']'+posName);
                        counter++;
                    }
                    //

                    nameIncrement++;

                    var_quoteGruop.html(function(i, oldHTML) {                    
                        oldHTML= oldHTML.replace('#1','#'+ (parseInt(max + 1)) ); 
                        oldHTML = oldHTML.replace('display:none', '');
                        return oldHTML;                     
                    });
                    
                    var_quoteGruop.insertAfter('.quote-group:last');

                    if (total_forms > 1) {
                        $(".quote-group__delete").not(':first').show();
                    }
                    
                    MyApp.quote.CheckCountForms();
                    $('.delete_vehicle_1').hide();
                });
            }
        },
        CheckCountForms: function () {
            if ($(".quote-group").length == 1) {
                $(".quote-group__delete").hide();
            }
            else {
                $(".quote-group__delete").not(':first').show();
            }
        }
    },
    home: {
        findSlider: function () {
            $('.find-home-slick').slick({
                dots: true,
                arrows: true,
                prevArrow: '<button class="slide-arrow" find-prev aria-label="button slide prev"></button>',
                nextArrow: '<button class="slide-arrow" find-next aria-label="button slide next"></button>',
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 4000
            });
        },
        aboutSlider: function () {
            $('.about-slick').slick({
                dots: true,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        },
        testimoniesSlider: function () {
            $('.testimonials-slick').slick({
                dots: true,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 2,
                autoplay: false,
                autoplaySpeed: 4000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 650,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        },
        modal : function(){
            $('.modal-phone').on("click", function(e){
                e.preventDefault();
                $('.site__modals__phone').css('display','block');
            })
            $('.site__modals__phone__close').on("click", function(e){
                e.preventDefault();
                $('.site__modals__phone').css('display','none');
            })
            var modal = document.getElementById('myModal');
            window.onclick = function(event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            }
        }
    },
    dymanicTabs: {
        showTab: function () {
            $('.tabs__content > div').hide();
            $('.tabs__content > div:first-of-type').fadeIn();
            $('.tabLink').click(function(e){
                e.preventDefault();
                var $this = $(this),
                    tabgroup = '#'+$this.parents('.tabsGroup').data('tabgroup'),
                    others = $this.closest('li').siblings().children('a'),
                    target = $this.attr('href');
                others.removeClass('active');
                $this.addClass('active');
                $(tabgroup).children('div').hide();
                $(target).fadeIn();
            });
        }
    },
    footer: {
        submenu : function () {
            var coll = document.getElementsByClassName("collapsible");
            var i;

            for (i = 0; i < coll.length; i++) {
                coll[i].addEventListener("click", function() {
                    this.classList.toggle("active");
                    var content = this.nextElementSibling;
                    if (content.style.maxHeight){
                        content.style.maxHeight = null;
                    } else {
                        content.style.maxHeight = content.scrollHeight + "px";
                    } 
                });
            }
        }
    },
    insurance: {
        scrollForm: function() {
            $(".insurances__fixed__form__link").click(function(e){
                e.preventDefault();
                if ($(window).width() < 768){
                    $(this).toggleClass('is-active');
                    $(".insurances__fixed__form__box").slideToggle("slow");
                }
            });
            $(window).scroll(function() {
                var scrollDistance = $(window).scrollTop();
                // Assign active class to nav links while scolling
                if ($('.insurances__activeFloat').position().top <= scrollDistance) {
                    $('.insurances__fixed__form').addClass('active');
                    /*$('.site-footer__legal').addClass('is-active');*/
                }else{
                    $('.insurances__fixed__form.active').removeClass('active');
                }
            }).scroll();
            if ($(window).width() < 768){
                $(window).scroll(function() {
                    var scrollDistance = $(window).scrollTop();
                    // Assign active class to nav links while scolling
                    if ($('.insurances__activeFloat').position().top <= scrollDistance) {
                        $('.insurances__fixed__form').addClass('active');
                    }else{
                        $('.insurances__floatForm.active').removeClass('active');
                        $('.insurances__fixed__form__link').removeClass('is-active');
                        $(".insurances__fixed__form__box").slideUp("slow");
                    }
                }).scroll();
            }
            $(window).on("scroll", function() {
                var scrollHeight = $(document).height();
                var scrollPosition = $(window).height() + $(window).scrollTop();
                if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
                    $('.insurances__fixed__form.active').removeClass('active');
                }
            });
        }
    },
    faq: {
        tabCollapse: function(){
            $(document).ready(function() {
                var coll = document.getElementsByClassName("faq__card__header");
                var i;

                for (i = 0; i < coll.length; i++) {
                    coll[i].addEventListener("click", function(event) {
                        event.preventDefault();
                        this.classList.toggle("active");
                        var faq__card__content = this.nextElementSibling;
                        if (faq__card__content.style.maxHeight){
                            faq__card__content.style.maxHeight = null;
                        } else {
                            faq__card__content.style.maxHeight = faq__card__content.scrollHeight + "px";
                        } 
                    });
                }
            });
        }
    },
    locations: {
        locationForm: function(){
            $('.formlocation').validate({
                errorPlacement: function(error, element) {
                    error.insertAfter(element);
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest(".validate__item").addClass(errorClass).removeClass("validate__success")
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest(".validate__item").removeClass(errorClass).addClass("validate__success")
                },
                errorElement:'span',
                errorClass: 'validate__error',
                rules:{
                    address: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5
                    }
                },
                messages: {
                    address: {
                        required: 'Zip Code is required'
                    }
                }
            });
        }
    },
    officeProfile: {
        officeProForm: function(){
            jQuery.validator.setDefaults({
                debug: true,
                success: "valid"
            });
            var form = $(".formOffice");
            form.validate({
                errorPlacement: function(error, element) {
                    error.insertAfter(element);
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest(".validate__item").addClass(errorClass).removeClass("validate__success")
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest(".validate__item").removeClass(errorClass).addClass("validate__success")
                },
                errorElement:'span',
                errorClass: 'validate__error',
                rules:{
                    from: {minlength:2},
                    office: {minlength:2}
                },
                messages: {
                    from: {
                        required: 'From is required'
                    },
                    office: {
                        required: 'Office Address is required'
                    }
                },
                submitHandler: function(form, event) {
                    event.preventDefault();
                }
            });
            $(".office__directions-button").click(function() {
                form.valid();
            });
        }
    }
}
const osanoTrigger = {
    init() {
        const triggers = document.querySelectorAll('.js-osano-trigger');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', event => {
                event.preventDefault();
                Osano.cm.showDoNotSell();
                const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
                closeButtonDialog?.focus();
            });
        });
    }
};

window.addEventListener('load', event => {
    osanoTrigger.init();
});

// On ready

$(function () {
    MyApp.menu.open();
    MyApp.menu.fixed();
    MyApp.menu.overlayDesktop();
    MyApp.menu.overlayMobile();
    MyApp.menu.submenu();
    MyApp.menu.closeSubmenu();
    MyApp.menu.windowResize();
    MyApp.footer.submenu();

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }
    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }
    if ($('.only-alpha-numeric').length) {
        MyApp.onlyAlpaNumeric();
    }
    if ($('.only-phone').length) {
        MyApp.onlyPhone();
    }
    if ($('.only-date').length) {
        MyApp.onlyDate();
    }
    if ($('.form').length) {
        MyApp.quote.form();
        MyApp.quote.phone();
    }
    if ($('.vehicles-form').length) {
        MyApp.quote.vehicles.vehiclesForm();
        MyApp.quote.vehicles.addVehicles();
    }
    if ($('.quote-group__delete').length) {
        MyApp.quote.deleteItem();
        MyApp.quote.deleteItemYes();
        MyApp.quote.deleteItemNo();
    }
    if ($('.site__modals__phone').length) {
        MyApp.home.modal();
    }
    if ($('.find-home-slick').length) {
        MyApp.home.findSlider();
    }
    if ($('.about-slick').length) {
        MyApp.home.aboutSlider();
    }
    if ($('.testimonials-slick').length) {
        MyApp.home.testimoniesSlider();
    }
    if ($('.dinamycTabs').length) {
        MyApp.dymanicTabs.showTab();
    }
    if ($('.insurances__fixed__form').length) {
        MyApp.insurance.scrollForm();
    }
    if ($('.box__collapse').length) {
        MyApp.faq.tabCollapse();
    }
    if ($('.formlocation').length) {
        MyApp.locations.locationForm();
    }
    if ($('.formOffice').length) {
        MyApp.officeProfile.officeProForm();
    }
});